import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

export interface CompleteScreenViewModel {
  readonly profileNickname: string;
  readonly exerciseTitle: string;
  readonly savedAttempts: number;
}

@Component({
  selector: 'app-complete-screen',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (view(); as state) {
      <section class="card child-card complete-card">
        <div class="completion-badge" aria-hidden="true">★</div>
        <p class="celebration" aria-hidden="true">🌱 🌼 🌱</p>
        <h1>Bravissimo, {{ state.profileNickname }}!</h1>
        <p class="completion-copy">Hai completato {{ state.exerciseTitle }}.</p>

        <div class="completion-actions">
          <button class="primary primary-large" type="button" (click)="restartExercise.emit()">
            <span aria-hidden="true">↻</span> Ancora
          </button>
          <button class="secondary primary-large" type="button" (click)="chooseAnotherActivity.emit()">
            <span aria-hidden="true">🎲</span> Altri giochi
          </button>
        </div>

        <footer class="adult-tools completion-tools" aria-label="Strumenti per adulti">
          <span class="adult-tools-label">Per gli adulti</span>
          <p class="history">Tentativi salvati per questa skill: {{ state.savedAttempts }}</p>
          <div class="adult-tools-actions">
            <button class="quiet-button" type="button" (click)="openCurriculum.emit()">Programma e fonti</button>
            <button class="quiet-button" type="button" (click)="openAudioSettings.emit()">Audio e TTS</button>
            <button class="quiet-button" type="button" (click)="chooseAnotherProfile.emit()">Cambia bambino</button>
          </div>
        </footer>
      </section>
    }
  `,
  styleUrl: './complete-screen.component.scss'
})
export class CompleteScreenComponent {
  readonly view = input.required<CompleteScreenViewModel>();

  readonly restartExercise = output<void>();
  readonly chooseAnotherActivity = output<void>();
  readonly openCurriculum = output<void>();
  readonly openAudioSettings = output<void>();
  readonly chooseAnotherProfile = output<void>();
}
